import { createContext } from "react";

const ModalTitleContext = createContext(undefined);

export default ModalTitleContext;
